import React from 'react';
import { TipsMapType } from '..';

export const keywordTipsText: TipsMapType = {
  en: (
    <>
      The sentiment score of each keyword was obtained by averaging the
      sentiment score of all comments corresponding to each keyword.
      <br />
      Keywords with sentiment score less than 2.5 show red; between 2.5 to 3.5
      show gray; greater than 3.5 show green.
    </>
  ),
  zh: (
    <>
      通过对每个关键词对应的所有评论的情感分求平均，获得关键词的情感分。
      <br />
      其中关键词情感分小于 2.5 分的显示红色；处于 2.5 至 3.5 的显示灰色；大于
      3.5 的显示绿色。
    </>
  ),
};

export const keywordTipsMentionsText: TipsMapType = {
  en: (
    <>
      Because one review may have multiple keywords, the total reviews has been
      remove duplicates here.
      <br />
      The keyword percentage is obtained by dividing the number of reviews on
      the keyword by the number of total reviews(after removing duplicates).
    </>
  ),
  zh: (
    <>
      由于一条评论可能命中多个关键词，此处关键词的【总评论数】已进行去重处理。
      <br />
      关键词百分比是由【该关键词的评论数】除以【去重后的总评论数】获得。
    </>
  ),
};

export const selectedKeywordTipsText: TipsMapType = {
  en: (
    <>
      In order to improve the computational efficiency, we selected the mentions
      of the top 200 keywords and their related synonyms as total mentions. The
      reviews list displays reviews related to that keyword and all its
      synonyms, which may be slightly more numerous than the keyword cards.
    </>
  ),
  zh: (
    <>
      为了提高计算效率，选取声量排名前200的关键词及其相关同义词的声量聚合。评论区显示与该关键词及其所有同义词相关的评论，数量可能略多于关键词卡片。
    </>
  ),
};
